module.exports = __webpack_public_path__ + "img/uus_avaleht_1.f7af36c5.jpeg";